import { Component, forwardRef, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validator, NG_VALIDATORS, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { emailPattern, splitPattern } from '../../shared/constants';
import { ApiService } from '../../api.service';
declare const $: any;

@Component({
	selector: 'app-mail-form',
	templateUrl: './mail-form.component.html',
	styleUrl: './mail-form.component.scss',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => MailFormComponent),
			multi: true
		}
	]
})
export class MailFormComponent implements ControlValueAccessor, Validator, OnDestroy {
	form: FormGroup;
	private subs: Subscription[] = [];
	onChange = (_: any) => { };
	onTouched = () => { };
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	emailPatternValidator(control: FormControl) {
		const regex = emailPattern;
		if (!control.value.match(regex)) {
			return {
				'emailerr': true
			};
		}
		return null;
	};
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'font': [] }],
				[{ 'align': [] }]
			]
		}
	};
	splitPattern = splitPattern;
	onTextChangeDebounce = 500;
	/* suggestions_to: string[] = [];
	suggestions_cc: string[] = []; */
	suggestions: string[] = [
		"rskhuman@3cubeservices.com",
		"nsharma@3cubeservices.com",
		"nravani@3cubemedicare.com",
		"akhandekar@3cubemedicare.com",
		"paramjyot.sidhu@msc.com",
		"ravianand@3cubemedicare.com",
		"Raihan@3cubemedicare.com",
		"pni@angloeastern.com",
		"pgp@dockendale.net"
	];

	constructor(private apiService: ApiService, private fb: FormBuilder) {
		this.form = this.fb.group({
			toMail: [null, Validators.required],
			ccMail: [null],
			subject: [null, Validators.required],
			body: [null, Validators.required]
		});
		this.subs.push(
			this.form.valueChanges.subscribe(v => {
				this.onChange(v);
				this.onTouched();
			})
		);
	}

	writeValue(obj: any): void {
		if (obj) {
			this.form.patchValue(obj, { emitEvent: false });
		} else {
			this.form.reset({
				toMail: null,
				ccMail: null,
				subject: null,
				body: null
			}, { emitEvent: false });
		}
	}

	registerOnChange(fn: any): void { this.onChange = fn; }
	registerOnTouched(fn: any): void { this.onTouched = fn; }

	validate(): null | { nameInvalid: true } {
		return this.form.valid ? null : { nameInvalid: true };
	}

	ngOnDestroy() {
		this.subs.forEach(s => s.unsubscribe());
	}

	/* fetchReplyEmails(text: any, inputId: any) {
		if (text.length >= 3) {
			this.apiService.countryCodes().subscribe({
				next: (data: any) => {
					if (inputId == "toMail") {
						this.suggestions_to = data.map((e: any) => e.name);
					} else if (inputId == "ccMail") {
						this.suggestions_cc = data.map((e: any) => e.name);
					}
				}
			});
		}
	} */
}
